/**
 * TROC-353 — ERP Custom ID (`Employee.EID`) from UM wire (`customId` / `CustomId`).
 * May be a single value or a BE comma-separated aggregate across databases.
 * Never treat numeric EmpId as Custom ID.
 */
export function parseWireCustomId(record: Record<string, unknown>): string | null {
  const raw = record.customId ?? record.CustomId;
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  return trimmed === '' ? null : trimmed;
}

/** Deduped join with ", " (case-insensitive), preserving first-seen order. */
export function joinDistinctCustomIds(values: Array<string | null | undefined>): string | null {
  const seen = new Set<string>();
  const out: string[] = [];
  for (const value of values) {
    if (value == null) continue;
    const trimmed = value.trim();
    if (trimmed === '') continue;
    const key = trimmed.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(trimmed);
  }
  return out.length > 0 ? out.join(', ') : null;
}
